import React, {Component} from "react";
import PropTypes from "prop-types";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";

export class Web_DocLink extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    componentDidMount() {
    }

    getDocument = async () => {
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "EDDocList", "DownloadAdditionalDocument") + "?" + $.param({
            b_token: token,
            id: this.props.row.EDocIntId,
            doc_key: this.props.row.Doc_Key
        });
        window.open(downloadPath, '_blank');
    }

    render() {
        return (
            <div>
                <label>
                    <a href="" rel="noopener noreferrer"
                       onClick={(event) => this.getDocument()}
                       className="mr-2">{this.props.value}</a>
                </label>
            </div>
        )
    }
}

Web_DocLink.propTypes = {
    dispatch: PropTypes.func.isRequired
}

Web_DocLink.defaultProps = {};